import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveytext",
    template: ``,
    standalone: false
})
export class FormlyFieldSurveyTextComponent extends FieldType<FieldTypeConfig> {}
